const e = {
  sm: "1.4rem",
  md: "1.4rem",
  lg: "1.6rem"
};
export {
  e as fontSizes
};
//# sourceMappingURL=constants.es.js.map
